// extracted by mini-css-extract-plugin
module.exports = {"collapseIcon":"custom-collapse_collapseIcon__32Dfo"};